import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BookingStore, InstallationsStore } from '@store';

@Component({
  selector: 'app-booking-overview-flat-rate',
  templateUrl: './booking-overview-flat-rate.component.html',
  styleUrls: ['./booking-overview-flat-rate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingOverviewFlatRateComponent {
  constructor(public bookingStore: BookingStore, public installationsStore: InstallationsStore) {}
}
